import { DefaultKnownQueryParametersProvider as r } from "./index2.js";
function n() {
  return new r();
}
export {
  n as createKnownQueryParametersProvider
};
//# sourceMappingURL=index.js.map
